module OnlineDPR.Application.Client.UpdateTranslations

open Elmish
open Fable.React
open Fable.React.Props

open OnlineDPR.Application.Shared
open OnlineDPR.Application.Client.Components

type Msg =
| UpdateTranslationsRequested
| TranslationsUpdated of Result<bool, string>

let init() =
    UpdateTranslationsModel { Pending = None }, []

let triggerUpdateCommand() =
    Cmd.OfPromise.either
        (Http.postData APIUrls.UpdateTranslations)
        ""
        (TranslationsUpdated)
        (Http.toErrorMessage >> TranslationsUpdated)

let update msg (model:UpdateTranslationsModel) =
    match msg with
    | UpdateTranslationsRequested -> {model with Pending = Some true}, (triggerUpdateCommand())
    | TranslationsUpdated _ -> {model with Pending = Some false}, []

let loader() =
    spinner

let success() =
    span [] [str "Anforderung abgeschickt."]

let feedback = function
    | Some false -> success()
    | Some true -> loader()
    | None -> ofList []

let isEnabled = function
    | None -> false
    | _ -> true


let view model dispatch =
    [ div [] [ button [ OnClick (fun ev -> dispatch UpdateTranslationsRequested)
                        Disabled (isEnabled model.Pending) ]
                      [ str "Update Translations" ]
               span [ Class "feedback"] [feedback model.Pending ] ] ]
    |> ofList
